import { DatabaseRecord } from "@tellescope/types-models";

export const transformDatabasePage = (
  items: { choices: DatabaseRecord[] },
  { databaseLabel, databaseLabels }: { databaseLabel?: string; databaseLabels?: string[] }
): { value: string; label: string }[] => {
  return items.choices.map<{ label: string; value: string }>((item) => {
    const { values } = item;
    const { primaryLabel, secondaryLabels } = values.reduce<{ primaryLabel: string; secondaryLabels: string[] }>(
      (acc, curr) => {
        if (curr.label === databaseLabel && curr.value) {
          acc.primaryLabel = String(curr.value);
        }

        const secondaryLabels =
          databaseLabels?.reduce<string[]>((acc, curr) => {
            const match = item.values.find((value) => value.label === curr);
            if (match?.value) {
              acc.push(String(match.value));
            }

            return acc;
          }, []) ?? [];
        acc.secondaryLabels = secondaryLabels;

        return acc;
      },
      { primaryLabel: "", secondaryLabels: [] }
    );

    return {
      label: secondaryLabels.length ? `${primaryLabel} (${secondaryLabels.join(", ")})` : primaryLabel,
      value: item.id,
    };
  });
};
